import React from "react";
import Services from "../Services/Services";
import Banner from "../Shared/Banner/Banner";
import NewsLetter from "../NewsLetter/NewsLetter";

const Home = () => {
  return (
    <div>
      <Banner></Banner>
      <Services></Services>
      <NewsLetter></NewsLetter>
    </div>
  );
};

export default Home;
